// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__7DJNA","textareaLabel":"styles_textareaLabel__27tQP","textareaLabelText":"styles_textareaLabelText__RkoQC","textareaField":"styles_textareaField__R2ote"};